import { render } from "./UpdateResultsAdmin.vue?vue&type=template&id=d675b720&scoped=true"
import script from "./UpdateResultsAdmin.vue?vue&type=script&lang=js"
export * from "./UpdateResultsAdmin.vue?vue&type=script&lang=js"

import "./UpdateResultsAdmin.vue?vue&type=style&index=0&id=d675b720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d675b720"]])

export default __exports__